const notFound = {
  error: "ขออภัย， หน้าที่คุณเยี่ยมชมไม่มีอยู่",
  backHome: "กลับไปที่หน้าแรก"
} 
export default notFound